import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "8e8139ee-eb5e-4f67-88c5-288ecc5774af"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "d85e97da-2c29-44c8-aed8-0dedd24f88e8"
export function Footer8e8139eeEb5e4f6788c5288ecc5774af(props: any) {
  return (
    <DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 parentTag="Footer8e8139eeEb5e4f6788c5288ecc5774af" {...props} />
  );
}

// id: "1293791e-573c-4804-ad90-5d9bf9aea9fd"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "d85e97da-2c29-44c8-aed8-0dedd24f88e8"
export function Header1293791e573c4804Ad905d9bf9aea9fd(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header1293791e573c4804Ad905d9bf9aea9fd" parentTag={buildClassName("Header1293791e573c4804Ad905d9bf9aea9fd", parentTag)} subType="header_with_hero" contentSlug="local-partnership-header-with-hero" as="header" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "d85e97da-2c29-44c8-aed8-0dedd24f88e8"
// title: "Local Partnership"
// type: :html
// key: "local-partnership-page"
// parent_id: nil
export function LocalPartnershipPageD85e97da2c2944c8Aed80dedd24f88e8(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} LocalPartnershipPageD85e97da2c2944c8Aed80dedd24f88e8 gf-page-layout`}>
      {props["header"] || <ContentItem className="Header1293791e573c4804Ad905d9bf9aea9fd" parentTag={buildClassName("Header1293791e573c4804Ad905d9bf9aea9fd", parentTag)} subType="header_with_hero" contentSlug="local-partnership-header-with-hero" as="header" className="public-header-with-hero secondary-page" {...props} />}
      <main>
        {props["page-content"] || <PageContentSimplified className="PageContentB7c9d5951033415087202ca50e428f07" parentTag={buildClassName("PageContentB7c9d5951033415087202ca50e428f07", parentTag)} className="main-inner" {...props} />}
      </main>
      {props["footer"] || <DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 parentTag="Footer8e8139eeEb5e4f6788c5288ecc5774af" {...props} />}
    </div>
  );
}

// id: "68df6b9a-25c8-45c2-be4a-7365aceb2d63"
// title: ""
// type: :text
// key: "subType"
// parent_id: "1293791e-573c-4804-ad90-5d9bf9aea9fd"
export const SubType68df6b9a25c845c2Be4a7365aceb2d63 = "header_with_hero";

// id: "fd97021e-5737-4943-a305-7de337a8b369"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "1293791e-573c-4804-ad90-5d9bf9aea9fd"
export const ContentSlugFd97021e57374943A3057de337a8b369 = "local-partnership-header-with-hero";

// id: "37abe6e6-be80-4809-9a82-c67b6e101ecb"
// title: ""
// type: :text
// key: "as"
// parent_id: "1293791e-573c-4804-ad90-5d9bf9aea9fd"
export const As37abe6e6Be8048099a82C67b6e101ecb = "header";

// id: "97e3f251-35c7-4699-be2c-8f9af19bf83f"
// title: ""
// type: :text
// key: "className"
// parent_id: "1293791e-573c-4804-ad90-5d9bf9aea9fd"
export const ClassName97e3f25135c74699Be2c8f9af19bf83f = "public-header-with-hero secondary-page";

// id: "b7c9d595-1033-4150-8720-2ca50e428f07"
// title: "Local Partnership - Page Content"
// type: :gf_preset
// key: "page-content"
// parent_id: "d85e97da-2c29-44c8-aed8-0dedd24f88e8"
export function PageContentB7c9d5951033415087202ca50e428f07(props: any) {
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="PageContentB7c9d5951033415087202ca50e428f07" parentTag={buildClassName("PageContentB7c9d5951033415087202ca50e428f07", parentTag)} className="main-inner" {...props} />
  );
}

// id: "1ef4a984-5023-49da-a9cb-bc20dd3e8ebf"
// title: ""
// type: :text
// key: "class"
// parent_id: "b7c9d595-1033-4150-8720-2ca50e428f07"
export const Class1ef4a984502349daA9cbBc20dd3e8ebf = "main-inner";

// id: "24ec4652-d49c-4a82-bc89-787abeecd5e1"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTop24ec4652D49c4a82Bc89787abeecd5e1(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTop24ec4652D49c4a82Bc89787abeecd5e1 header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogoE5e6df9627984d11Af7bA8aefd54ee6d" parentTag={buildClassName("LinkedLogoE5e6df9627984d11Af7bA8aefd54ee6d", parentTag)} label={<Logo className="Label15eccd7013424328B2a88767782bc61c" parentTag={buildClassName("Label15eccd7013424328B2a88767782bc61c", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} className="linked-logo" url="/" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="Navigation010614acCf8a4eb6Bdb4753417deb98f" parentTag={buildClassName("Navigation010614acCf8a4eb6Bdb4753417deb98f", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />}
    </div>
  );
}

// id: "abeb3bbf-3790-485c-9a49-146f8ef4e521"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeaderAbeb3bbf3790485c9a49146f8ef4e521(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeaderAbeb3bbf3790485c9a49146f8ef4e521 site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTop24ec4652D49c4a82Bc89787abeecd5e1 parentTag="HeaderTopC4a8053185f64858A33189694515dada" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHeroBb1388ebCab7426aB006689d73d56336 parentTag="Hero1ae07dd2D1f04c74B886Dd16de9b48e1" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "b8b9bef9-3566-4bc6-9e4e-bb11f70aa588"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPageB8b9bef935664bc69e4eBb11f70aa588(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPageB8b9bef935664bc69e4eBb11f70aa588 gf-page-layout`}>
      {props["header"] || <ContentItem className="Header09c95615207c4204Bcce87f12373a71f" parentTag={buildClassName("Header09c95615207c4204Bcce87f12373a71f", parentTag)} subType="header_with_hero" contentSlug="about-us-header-with-hero" as="header" className="public-header-with-hero secondary-page" {...props} />}
      {props["main"] || <MainCd8a74f2Bda549c0A1fb7144fe3395e1 />}
      {props["footer"] || <DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 parentTag="FooterEbbaf61e4a93453e9bd75541ce63dcb6" {...props} />}
    </div>
  );
}

// id: "77ee98ee-3852-4f15-9c03-08335faf554b"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPage77ee98ee38524f159c0308335faf554b(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPage77ee98ee38524f159c0308335faf554b`}>
      {props["header"] || <ContentItem className="HeaderE04c5be0D4354297B914Cb2b7ee853a3" parentTag={buildClassName("HeaderE04c5be0D4354297B914Cb2b7ee853a3", parentTag)} title="Public Events" subType="header_with_hero" contentSlug="public-events-header-with-hero" as="header" className="public-header-with-hero secondary-page" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 parentTag="Footer245b4087231f480a900b4d149734da09" {...props} />}
    </div>
  );
}

// id: "f56cb81a-742a-45f1-8685-8f9f64d174d9"
// title: "Join Us Page"
// type: :html
// key: "join-us-page"
// parent_id: nil
export function JoinUsPageF56cb81a742a45f186858f9f64d174d9(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} JoinUsPageF56cb81a742a45f186858f9f64d174d9`}>
      {props["header"] || <ContentItem className="Header6252f33e538f4de392ec2d60827ba2fc" parentTag={buildClassName("Header6252f33e538f4de392ec2d60827ba2fc", parentTag)} subType="header_with_hero" contentSlug="join-us-header-with-hero" as="header" className="public-header-with-hero secondary-page" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 parentTag="FooterB16e3209483d415cA306Caba885a5d74" {...props} />}
    </div>
  );
}

// id: "0ed336a0-cebe-4984-bdbf-45bd5ca0af28"
// title: "Member Application Pages"
// type: :reference
// key: "application-pages"
// parent_id: nil
export function ApplicationPages0ed336a0Cebe4984Bdbf45bd5ca0af28(props: any) {
  return (
    <SecondaryPage4b047484Dc1948a2Bf01C1c5a44447b1 parentTag="ApplicationPages0ed336a0Cebe4984Bdbf45bd5ca0af28" header={<SecondaryMarketingHeaderAbeb3bbf3790485c9a49146f8ef4e521 parentTag="HeaderE96366629c5647fd8a35C339265df594" title="Join Us" />} {...props} />
  );
}

// id: "d2f741c8-5fed-404e-b6c1-c8b710c789ba"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "d381f58e-36d8-4e3b-9b87-e52cadfa7213"
export function GroupflowD2f741c85fed404eB6c1C8b710c789ba(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="GroupflowD2f741c85fed404eB6c1C8b710c789ba" parentTag={buildClassName("GroupflowD2f741c85fed404eB6c1C8b710c789ba", parentTag)} {...props} />
  );
}

// id: "a379cfa6-c558-4d11-8a7e-efde248f5b01"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "24ec4652-d49c-4a82-bc89-787abeecd5e1"
export function LogoA379cfa6C5584d118a7eEfde248f5b01(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LogoA379cfa6C5584d118a7eEfde248f5b01" parentTag={buildClassName("LogoA379cfa6C5584d118a7eEfde248f5b01", parentTag)} logoType="DEFAULT" {...props} />
  );
}

// id: "c4a80531-85f6-4858-a331-89694515dada"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "abeb3bbf-3790-485c-9a49-146f8ef4e521"
export function HeaderTopC4a8053185f64858A33189694515dada(props: any) {
  return (
    <DefaultHeaderTop24ec4652D49c4a82Bc89787abeecd5e1 parentTag="HeaderTopC4a8053185f64858A33189694515dada" {...props} />
  );
}

// id: "d4ba98de-aa0e-4d9c-aab8-c08b09d4e0a7"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "d381f58e-36d8-4e3b-9b87-e52cadfa7213"
export function LogoD4ba98deAa0e4d9cAab8C08b09d4e0a7(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LogoD4ba98deAa0e4d9cAab8C08b09d4e0a7" parentTag={buildClassName("LogoD4ba98deAa0e4d9cAab8C08b09d4e0a7", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "fe777d74-5c6b-44bf-a88c-f61375f38046"
// title: "Home Header Wrapper"
// type: :html
// key: "header-wrapper"
// parent_id: "4192a8ed-a2cd-4722-a59e-d974e90caa4e"
export function HeaderWrapperFe777d745c6b44bfA88cF61375f38046(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeaderWrapperFe777d745c6b44bfA88cF61375f38046`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTop24ec4652D49c4a82Bc89787abeecd5e1 parentTag="HeaderTop1ff5b58e64bb4e6d9e67E9e7bb83d203" {...props} />}
      </div>
      {props["hero-wrapper"] || <HeroWrapper81da98e7Ae5f45cc99b9182b4cac5053 />}
    </div>
  );
}

// id: "245b4087-231f-480a-900b-4d149734da09"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "77ee98ee-3852-4f15-9c03-08335faf554b"
export function Footer245b4087231f480a900b4d149734da09(props: any) {
  return (
    <DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 parentTag="Footer245b4087231f480a900b4d149734da09" {...props} />
  );
}

// id: "e5e6df96-2798-4d11-af7b-a8aefd54ee6d"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "24ec4652-d49c-4a82-bc89-787abeecd5e1"
export function LinkedLogoE5e6df9627984d11Af7bA8aefd54ee6d(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogoE5e6df9627984d11Af7bA8aefd54ee6d" parentTag={buildClassName("LinkedLogoE5e6df9627984d11Af7bA8aefd54ee6d", parentTag)} label={<Logo className="Label15eccd7013424328B2a88767782bc61c" parentTag={buildClassName("Label15eccd7013424328B2a88767782bc61c", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} className="linked-logo" url="/" {...props} />
  );
}

// id: "36f98216-ddc0-4eaa-a675-c4d3dd26646c"
// title: ""
// type: :text
// key: "title"
// parent_id: "bb1388eb-cab7-426a-b006-689d73d56336"
export const Title36f98216Ddc04eaaA675C4d3dd26646c = "Default Title";

// id: "8d7e818f-9aed-49b7-a224-a8c62df3f3e4"
// title: "Home Main"
// type: :html
// key: "main"
// parent_id: "4192a8ed-a2cd-4722-a59e-d974e90caa4e"
export function Main8d7e818f9aed49b7A224A8c62df3f3e4(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} Main8d7e818f9aed49b7A224A8c62df3f3e4`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards539c40c0A80d41afBd4550efbba2d26b" parentTag={buildClassName("Cards539c40c0A80d41afBd4550efbba2d26b", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-cards" {...props} />}
      </div>
      {props["quote"] || <PageQuote className="Quote61b9e7c198a1478a8e0361fb1e54a8e4" parentTag={buildClassName("Quote61b9e7c198a1478a8e0361fb1e54a8e4", parentTag)} contentSlug="home-page-quote" {...props} />}
    </main>
  );
}

// id: "9865fab4-9fff-4df6-8eea-bb33ac258d6e"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "4192a8ed-a2cd-4722-a59e-d974e90caa4e"
export function WelcomeBack9865fab49fff4df68eeaBb33ac258d6e(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack9865fab49fff4df68eeaBb33ac258d6e" parentTag={buildClassName("WelcomeBack9865fab49fff4df68eeaBb33ac258d6e", parentTag)} {...props} />
  );
}

// id: "cd8a74f2-bda5-49c0-a1fb-7144fe3395e1"
// title: ""
// type: :html
// key: "main"
// parent_id: "b8b9bef9-3566-4bc6-9e4e-bb11f70aa588"
export function MainCd8a74f2Bda549c0A1fb7144fe3395e1(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} MainCd8a74f2Bda549c0A1fb7144fe3395e1`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="CardsB6f339d235374c658f27A9e7d29a2b47" parentTag={buildClassName("CardsB6f339d235374c658f27A9e7d29a2b47", parentTag)} postSlug="about-us-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "e9636662-9c56-47fd-8a35-c339265df594"
// title: ""
// type: :reference
// key: "header"
// parent_id: "0ed336a0-cebe-4984-bdbf-45bd5ca0af28"
export function HeaderE96366629c5647fd8a35C339265df594(props: any) {
  return (
    <SecondaryMarketingHeaderAbeb3bbf3790485c9a49146f8ef4e521 parentTag="HeaderE96366629c5647fd8a35C339265df594" title="Join Us" {...props} />
  );
}

// id: "010614ac-cf8a-4eb6-bdb4-753417deb98f"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "24ec4652-d49c-4a82-bc89-787abeecd5e1"
export function Navigation010614acCf8a4eb6Bdb4753417deb98f(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation010614acCf8a4eb6Bdb4753417deb98f" parentTag={buildClassName("Navigation010614acCf8a4eb6Bdb4753417deb98f", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "e04c5be0-d435-4297-b914-cb2b7ee853a3"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "77ee98ee-3852-4f15-9c03-08335faf554b"
export function HeaderE04c5be0D4354297B914Cb2b7ee853a3(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderE04c5be0D4354297B914Cb2b7ee853a3" parentTag={buildClassName("HeaderE04c5be0D4354297B914Cb2b7ee853a3", parentTag)} title="Public Events" subType="header_with_hero" contentSlug="public-events-header-with-hero" as="header" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "6adc52ce-143f-4f34-a0ac-9fa29c85c96c"
// title: ""
// type: :text
// key: "title"
// parent_id: "abeb3bbf-3790-485c-9a49-146f8ef4e521"
export const Title6adc52ce143f4f34A0ac9fa29c85c96c = "Secondary Marketing Title 1";

// id: "46aef82d-7fb0-48d0-9241-86bfc74d5dc0"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "d381f58e-36d8-4e3b-9b87-e52cadfa7213"
export function Links46aef82d7fb048d0924186bfc74d5dc0(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links46aef82d7fb048d0924186bfc74d5dc0" parentTag={buildClassName("Links46aef82d7fb048d0924186bfc74d5dc0", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "69cd08b9-b042-4c18-a7e1-62b4bc101777"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "4b047484-dc19-48a2-bf01-c1c5a44447b1"
export function Header69cd08b9B0424c18A7e162b4bc101777(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header69cd08b9B0424c18A7e162b4bc101777" parentTag={buildClassName("Header69cd08b9B0424c18A7e162b4bc101777", parentTag)} title="Secondary Page" subType="header_with_hero" contentSlug="join-us-header-with-hero" as="header" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "ebbaf61e-4a93-453e-9bd7-5541ce63dcb6"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "b8b9bef9-3566-4bc6-9e4e-bb11f70aa588"
export function FooterEbbaf61e4a93453e9bd75541ce63dcb6(props: any) {
  return (
    <DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 parentTag="FooterEbbaf61e4a93453e9bd75541ce63dcb6" {...props} />
  );
}

// id: "1ae07dd2-d1f0-4c74-b886-dd16de9b48e1"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "abeb3bbf-3790-485c-9a49-146f8ef4e521"
export function Hero1ae07dd2D1f04c74B886Dd16de9b48e1(props: any) {
  return (
    <SecondaryMarketingHeroBb1388ebCab7426aB006689d73d56336 parentTag="Hero1ae07dd2D1f04c74B886Dd16de9b48e1" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "131fdaf5-bb7b-47a2-810d-89ff0f67c719"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "4b047484-dc19-48a2-bf01-c1c5a44447b1"
export function Footer131fdaf5Bb7b47a2810d89ff0f67c719(props: any) {
  return (
    <DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 parentTag="Footer131fdaf5Bb7b47a2810d89ff0f67c719" {...props} />
  );
}

// id: "89733e15-b74a-49ed-bc26-d9a2f069bfde"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "d381f58e-36d8-4e3b-9b87-e52cadfa7213"
export function Copyright89733e15B74a49edBc26D9a2f069bfde(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright89733e15B74a49edBc26D9a2f069bfde" parentTag={buildClassName("Copyright89733e15B74a49edBc26D9a2f069bfde", parentTag)} {...props} />
  );
}

// id: "8cc28b5a-a911-45ef-9d81-c328ac8db8ab"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "4192a8ed-a2cd-4722-a59e-d974e90caa4e"
export function Quote8cc28b5aA91145ef9d81C328ac8db8ab(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="Quote8cc28b5aA91145ef9d81C328ac8db8ab" parentTag={buildClassName("Quote8cc28b5aA91145ef9d81C328ac8db8ab", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "8489f269-2f64-4c7a-b6c7-5a89f3dd514c"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "4192a8ed-a2cd-4722-a59e-d974e90caa4e"
export function Footer8489f2692f644c7aB6c75a89f3dd514c(props: any) {
  return (
    <DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 parentTag="Footer8489f2692f644c7aB6c75a89f3dd514c" {...props} />
  );
}

// id: "15eccd70-1342-4328-b2a8-8767782bc61c"
// title: "Home Page Logo"
// type: :gf_preset
// key: "label"
// parent_id: "e5e6df96-2798-4d11-af7b-a8aefd54ee6d"
export function Label15eccd7013424328B2a88767782bc61c(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Label15eccd7013424328B2a88767782bc61c" parentTag={buildClassName("Label15eccd7013424328B2a88767782bc61c", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />
  );
}

// id: "80df85f2-0835-4e17-9d81-d83eda32b9ed"
// title: ""
// type: :text
// key: "class"
// parent_id: "010614ac-cf8a-4eb6-bdb4-753417deb98f"
export const Class80df85f208354e179d81D83eda32b9ed = "navigation";

// id: "ca4df4af-1c21-488d-86bc-4861adacf55d"
// title: ""
// type: :text
// key: "class"
// parent_id: "e5e6df96-2798-4d11-af7b-a8aefd54ee6d"
export const ClassCa4df4af1c21488d86bc4861adacf55d = "linked-logo";

// id: "81da98e7-ae5f-45cc-99b9-182b4cac5053"
// title: ""
// type: :html
// key: "hero-wrapper"
// parent_id: "fe777d74-5c6b-44bf-a88c-f61375f38046"
export function HeroWrapper81da98e7Ae5f45cc99b9182b4cac5053(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeroWrapper81da98e7Ae5f45cc99b9182b4cac5053`}>
      {props["hero"] || <Hero className="Hero1ef4e20615b14654Bf7015286bab1bc5" parentTag={buildClassName("Hero1ef4e20615b14654Bf7015286bab1bc5", parentTag)} postSlug="home-hero" {...props} />}
    </div>
  );
}

// id: "b6f339d2-3537-4c65-8f27-a9e7d29a2b47"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "cd8a74f2-bda5-49c0-a1fb-7144fe3395e1"
export function CardsB6f339d235374c658f27A9e7d29a2b47(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="CardsB6f339d235374c658f27A9e7d29a2b47" parentTag={buildClassName("CardsB6f339d235374c658f27A9e7d29a2b47", parentTag)} postSlug="about-us-cards" {...props} />
  );
}

// id: "e77cd94d-4983-44f5-8233-aa37b8036c65"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "8cc28b5a-a911-45ef-9d81-c328ac8db8ab"
export const ContentSlugE77cd94d498344f58233Aa37b8036c65 = "home-page-quote";

// id: "1ff5b58e-64bb-4e6d-9e67-e9e7bb83d203"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "fe777d74-5c6b-44bf-a88c-f61375f38046"
export function HeaderTop1ff5b58e64bb4e6d9e67E9e7bb83d203(props: any) {
  return (
    <DefaultHeaderTop24ec4652D49c4a82Bc89787abeecd5e1 parentTag="HeaderTop1ff5b58e64bb4e6d9e67E9e7bb83d203" {...props} />
  );
}

// id: "48bee644-052f-434d-955a-31d3a489896e"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "a379cfa6-c558-4d11-8a7e-efde248f5b01"
export const LogoType48bee644052f434d955a31d3a489896e = "DEFAULT";

// id: "d6d5f651-de62-4798-8c92-ce313f495489"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "010614ac-cf8a-4eb6-bdb4-753417deb98f"
export const NavMenuSlugD6d5f651De6247988c92Ce313f495489 = "marketing-primary-nav";

// id: "943484e1-bc4f-4802-a072-018e2a8d31ca"
// title: ""
// type: :text
// key: "title"
// parent_id: "69cd08b9-b042-4c18-a7e1-62b4bc101777"
export const Title943484e1Bc4f4802A072018e2a8d31ca = "Secondary Page";

// id: "3e3303ba-1cfa-4955-b15e-4eaa9d6736b4"
// title: ""
// type: :text
// key: "title"
// parent_id: "e04c5be0-d435-4297-b914-cb2b7ee853a3"
export const Title3e3303ba1cfa4955B15e4eaa9d6736b4 = "Public Events";

// id: "f38656c3-f354-4899-b3be-223dd0a55358"
// title: ""
// type: :text
// key: "url"
// parent_id: "e5e6df96-2798-4d11-af7b-a8aefd54ee6d"
export const UrlF38656c3F3544899B3be223dd0a55358 = "/";

// id: "539c40c0-a80d-41af-bd45-50efbba2d26b"
// title: "Home Cards"
// type: :gf_preset
// key: "cards"
// parent_id: "8d7e818f-9aed-49b7-a224-a8c62df3f3e4"
export function Cards539c40c0A80d41afBd4550efbba2d26b(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards539c40c0A80d41afBd4550efbba2d26b" parentTag={buildClassName("Cards539c40c0A80d41afBd4550efbba2d26b", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-cards" {...props} />
  );
}

// id: "ee6c48e0-aad0-435a-9d84-6e7e51070eb1"
// title: ""
// type: :text
// key: "title"
// parent_id: "e9636662-9c56-47fd-8a35-c339265df594"
export const TitleEe6c48e0Aad0435a9d846e7e51070eb1 = "Join Us";

// id: "f03a0077-553f-405d-abe1-54e00ef8d85e"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "46aef82d-7fb0-48d0-9241-86bfc74d5dc0"
export const NavMenuSlugF03a0077553f405dAbe154e00ef8d85e = "footer-nav";

// id: "d8b7ba33-a3b8-4217-9007-107f5079ad38"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "d4ba98de-aa0e-4d9c-aab8-c08b09d4e0a7"
export const LogoTypeD8b7ba33A3b842179007107f5079ad38 = "FOOTER";

// id: "51b9d6e4-6c6f-45ce-9d3b-9503b5f20c67"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "d4ba98de-aa0e-4d9c-aab8-c08b09d4e0a7"
export const ContentSlug51b9d6e46c6f45ce9d3b9503b5f20c67 = "footer-logo";

// id: "37b5fa9f-f138-477c-a66a-5b051294e2b6"
// title: ""
// type: :text
// key: "title"
// parent_id: "1ae07dd2-d1f0-4c74-b886-dd16de9b48e1"
export const Title37b5fa9fF138477cA66a5b051294e2b6 = "Secondary Marketing Title 2";

// id: "9516ed86-7427-421a-9d7b-2e5dda700f3d"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "539c40c0-a80d-41af-bd45-50efbba2d26b"
export const ButtonClass9516ed867427421a9d7b2e5dda700f3d = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "150b6d18-5e7d-4fc9-80d2-13416cd60630"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "539c40c0-a80d-41af-bd45-50efbba2d26b"
export const PostSlug150b6d185e7d4fc980d213416cd60630 = "home-page-cards";

// id: "1ef4e206-15b1-4654-bf70-15286bab1bc5"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "81da98e7-ae5f-45cc-99b9-182b4cac5053"
export function Hero1ef4e20615b14654Bf7015286bab1bc5(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="Hero1ef4e20615b14654Bf7015286bab1bc5" parentTag={buildClassName("Hero1ef4e20615b14654Bf7015286bab1bc5", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "91a4f9cf-d131-4090-a2f7-50cd4d7da9ba"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "15eccd70-1342-4328-b2a8-8767782bc61c"
export const LogoType91a4f9cfD1314090A2f750cd4d7da9ba = "DEFAULT";

// id: "f82550dc-0708-4de6-bb62-28bf8c69cac0"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "b6f339d2-3537-4c65-8f27-a9e7d29a2b47"
export const PostSlugF82550dc07084de6Bb6228bf8c69cac0 = "about-us-cards";

// id: "6a8810fa-a314-419c-bc05-c0bf49d20181"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "15eccd70-1342-4328-b2a8-8767782bc61c"
export const ContentSlug6a8810faA314419cBc05C0bf49d20181 = "header-logo";

// id: "091ccf90-1a04-4e9d-bba2-2e191606ab17"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "1ef4e206-15b1-4654-bf70-15286bab1bc5"
export const PostSlug091ccf901a044e9dBba22e191606ab17 = "home-hero";

// id: "5ce8d7b5-e077-4b40-93f2-76d4322a5340"
// title: ""
// type: :text
// key: "subType"
// parent_id: "69cd08b9-b042-4c18-a7e1-62b4bc101777"
export const SubType5ce8d7b5E0774b4093f276d4322a5340 = "header_with_hero";

// id: "c619fd51-9bf6-4bca-98eb-fd8eca48b734"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "69cd08b9-b042-4c18-a7e1-62b4bc101777"
export const ContentSlugC619fd519bf64bca98ebFd8eca48b734 = "join-us-header-with-hero";

// id: "c1480893-b1bd-4aa5-acca-d63e5cfa82a1"
// title: ""
// type: :text
// key: "as"
// parent_id: "69cd08b9-b042-4c18-a7e1-62b4bc101777"
export const AsC1480893B1bd4aa5AccaD63e5cfa82a1 = "header";

// id: "3c9fc99e-9ebf-4bd4-8699-058055848e7e"
// title: ""
// type: :text
// key: "className"
// parent_id: "69cd08b9-b042-4c18-a7e1-62b4bc101777"
export const ClassName3c9fc99e9ebf4bd48699058055848e7e = "public-header-with-hero secondary-page";

// id: "59960903-2cf6-4abf-a542-108e67559326"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "9b1ae4c4-e9ad-4b19-968c-68e997e5436a"
export function Footer599609032cf64abfA542108e67559326(props: any) {
  return (
    <DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 parentTag="Footer599609032cf64abfA542108e67559326" {...props} />
  );
}

// id: "47cb8600-4fd9-47fd-9ce8-dadb8703004e"
// title: "Contact Header"
// type: :gf_preset
// key: "header"
// parent_id: "9b1ae4c4-e9ad-4b19-968c-68e997e5436a"
export function Header47cb86004fd947fd9ce8Dadb8703004e(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header47cb86004fd947fd9ce8Dadb8703004e" parentTag={buildClassName("Header47cb86004fd947fd9ce8Dadb8703004e", parentTag)} subType="header_with_hero" contentSlug="public-contact-header-with-hero" className="public-header-with-hero secondary-page" as="header" {...props} />
  );
}

// id: "9b1ae4c4-e9ad-4b19-968c-68e997e5436a"
// title: "Contact Us"
// type: :html
// key: "public-contact-page"
// parent_id: nil
export function PublicContactPage9b1ae4c4E9ad4b19968c68e997e5436a(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicContactPage9b1ae4c4E9ad4b19968c68e997e5436a gf-page-layout`}>
      {props["header"] || <ContentItem className="Header47cb86004fd947fd9ce8Dadb8703004e" parentTag={buildClassName("Header47cb86004fd947fd9ce8Dadb8703004e", parentTag)} subType="header_with_hero" contentSlug="public-contact-header-with-hero" className="public-header-with-hero secondary-page" as="header" {...props} />}
      <main>
        {props["content"] || <ContentItem className="Content6fd55c6a3cc3424192941ab87b33c3c1" parentTag={buildClassName("Content6fd55c6a3cc3424192941ab87b33c3c1", parentTag)} subType="post" contentSlug="public-contact-main-content" className="main-content" {...props} />}
      </main>
      {props["footer"] || <DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 parentTag="Footer599609032cf64abfA542108e67559326" {...props} />}
    </div>
  );
}

// id: "61b9e7c1-98a1-478a-8e03-61fb1e54a8e4"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "8d7e818f-9aed-49b7-a224-a8c62df3f3e4"
export function Quote61b9e7c198a1478a8e0361fb1e54a8e4(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="Quote61b9e7c198a1478a8e0361fb1e54a8e4" parentTag={buildClassName("Quote61b9e7c198a1478a8e0361fb1e54a8e4", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "9920565c-a419-4c78-94c2-e621afb22e45"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "4192a8ed-a2cd-4722-a59e-d974e90caa4e"
export function Header9920565cA4194c7894c2E621afb22e45(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header9920565cA4194c7894c2E621afb22e45" parentTag={buildClassName("Header9920565cA4194c7894c2E621afb22e45", parentTag)} subType="header_with_hero" contentSlug="home-header-with-hero" as="header" className="public-header-with-hero home-page" {...props} />
  );
}

// id: "7ddade68-5432-4941-8572-ad1ba781a7f1"
// title: ""
// type: :text
// key: "subType"
// parent_id: "9920565c-a419-4c78-94c2-e621afb22e45"
export const SubType7ddade68543249418572Ad1ba781a7f1 = "header_with_hero";

// id: "a2525041-62a3-4e76-9db1-0cf36111d142"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "9920565c-a419-4c78-94c2-e621afb22e45"
export const ContentSlugA252504162a34e769db10cf36111d142 = "home-header-with-hero";

// id: "bed9fc9b-2350-4a76-b378-6ba62cc3b59d"
// title: ""
// type: :text
// key: "as"
// parent_id: "9920565c-a419-4c78-94c2-e621afb22e45"
export const AsBed9fc9b23504a76B3786ba62cc3b59d = "header";

// id: "daaf050d-a07a-419f-aaa4-8d63417f1ee6"
// title: ""
// type: :text
// key: "className"
// parent_id: "9920565c-a419-4c78-94c2-e621afb22e45"
export const ClassNameDaaf050dA07a419fAaa48d63417f1ee6 = "public-header-with-hero home-page";

// id: "6252f33e-538f-4de3-92ec-2d60827ba2fc"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "f56cb81a-742a-45f1-8685-8f9f64d174d9"
export function Header6252f33e538f4de392ec2d60827ba2fc(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header6252f33e538f4de392ec2d60827ba2fc" parentTag={buildClassName("Header6252f33e538f4de392ec2d60827ba2fc", parentTag)} subType="header_with_hero" contentSlug="join-us-header-with-hero" as="header" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "53112ed1-2e99-460f-8ff0-83e287ca2f53"
// title: ""
// type: :text
// key: "subType"
// parent_id: "6252f33e-538f-4de3-92ec-2d60827ba2fc"
export const SubType53112ed12e99460f8ff083e287ca2f53 = "header_with_hero";

// id: "6b1d4f6f-59c0-4454-80d9-cd5a181ba707"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "6252f33e-538f-4de3-92ec-2d60827ba2fc"
export const ContentSlug6b1d4f6f59c0445480d9Cd5a181ba707 = "join-us-header-with-hero";

// id: "6812c019-e3b5-419f-ad5b-0b0da035c03b"
// title: ""
// type: :text
// key: "as"
// parent_id: "6252f33e-538f-4de3-92ec-2d60827ba2fc"
export const As6812c019E3b5419fAd5b0b0da035c03b = "header";

// id: "2a14e1c1-0564-4384-9a38-6391827aa3df"
// title: ""
// type: :text
// key: "className"
// parent_id: "6252f33e-538f-4de3-92ec-2d60827ba2fc"
export const ClassName2a14e1c1056443849a386391827aa3df = "public-header-with-hero secondary-page";

// id: "52689960-8bcf-4585-8bc2-8e89c4237299"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "61b9e7c1-98a1-478a-8e03-61fb1e54a8e4"
export const ContentSlug526899608bcf45858bc28e89c4237299 = "home-page-quote";

// id: "90536bf5-2f52-430c-8219-d41c54301978"
// title: ""
// type: :text
// key: "subType"
// parent_id: "09c95615-207c-4204-bcce-87f12373a71f"
export const SubType90536bf52f52430c8219D41c54301978 = "header_with_hero";

// id: "216d39fc-2ce0-41b2-9b9b-f56ed3eb0f35"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "09c95615-207c-4204-bcce-87f12373a71f"
export const ContentSlug216d39fc2ce041b29b9bF56ed3eb0f35 = "about-us-header-with-hero";

// id: "e7cff4b8-6244-4805-bccf-1f30c314bf6e"
// title: ""
// type: :text
// key: "as"
// parent_id: "09c95615-207c-4204-bcce-87f12373a71f"
export const AsE7cff4b862444805Bccf1f30c314bf6e = "header";

// id: "78554e82-dd47-440a-81ce-54e6667720c8"
// title: ""
// type: :text
// key: "className"
// parent_id: "09c95615-207c-4204-bcce-87f12373a71f"
export const ClassName78554e82Dd47440a81ce54e6667720c8 = "public-header-with-hero secondary-page";

// id: "09c95615-207c-4204-bcce-87f12373a71f"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "b8b9bef9-3566-4bc6-9e4e-bb11f70aa588"
export function Header09c95615207c4204Bcce87f12373a71f(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header09c95615207c4204Bcce87f12373a71f" parentTag={buildClassName("Header09c95615207c4204Bcce87f12373a71f", parentTag)} subType="header_with_hero" contentSlug="about-us-header-with-hero" as="header" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "b16e3209-483d-415c-a306-caba885a5d74"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "f56cb81a-742a-45f1-8685-8f9f64d174d9"
export function FooterB16e3209483d415cA306Caba885a5d74(props: any) {
  return (
    <DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 parentTag="FooterB16e3209483d415cA306Caba885a5d74" {...props} />
  );
}

// id: "6fd55c6a-3cc3-4241-9294-1ab87b33c3c1"
// title: ""
// type: :gf_preset
// key: "content"
// parent_id: "9b1ae4c4-e9ad-4b19-968c-68e997e5436a"
export function Content6fd55c6a3cc3424192941ab87b33c3c1(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Content6fd55c6a3cc3424192941ab87b33c3c1" parentTag={buildClassName("Content6fd55c6a3cc3424192941ab87b33c3c1", parentTag)} subType="post" contentSlug="public-contact-main-content" className="main-content" {...props} />
  );
}

// id: "9c290f56-977a-4a32-bbfa-53e9095521a3"
// title: ""
// type: :text
// key: "subType"
// parent_id: "6fd55c6a-3cc3-4241-9294-1ab87b33c3c1"
export const SubType9c290f56977a4a32Bbfa53e9095521a3 = "post";

// id: "da358810-37e5-43ed-8ee0-3c5a4594e44e"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "6fd55c6a-3cc3-4241-9294-1ab87b33c3c1"
export const ContentSlugDa35881037e543ed8ee03c5a4594e44e = "public-contact-main-content";

// id: "0ceee5c3-f6d0-43cd-b8be-3b6cc67ae2b2"
// title: ""
// type: :text
// key: "className"
// parent_id: "6fd55c6a-3cc3-4241-9294-1ab87b33c3c1"
export const ClassName0ceee5c3F6d043cdB8be3b6cc67ae2b2 = "main-content";

// id: "1a1ff60a-f5bb-43ef-a73b-a297d73e9d23"
// title: ""
// type: :text
// key: "subType"
// parent_id: "47cb8600-4fd9-47fd-9ce8-dadb8703004e"
export const SubType1a1ff60aF5bb43efA73bA297d73e9d23 = "header_with_hero";

// id: "2bed7439-a4e0-4c34-9809-630f8be77b36"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "47cb8600-4fd9-47fd-9ce8-dadb8703004e"
export const ContentSlug2bed7439A4e04c349809630f8be77b36 = "public-contact-header-with-hero";

// id: "c7dfe1e2-ab54-42a0-bcf9-eb27b1785f6a"
// title: ""
// type: :text
// key: "className"
// parent_id: "47cb8600-4fd9-47fd-9ce8-dadb8703004e"
export const ClassNameC7dfe1e2Ab5442a0Bcf9Eb27b1785f6a = "public-header-with-hero secondary-page";

// id: "d10efa2a-43d0-4784-8b07-fc8195623065"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "cea9d9ef-69ee-4971-8cab-b2f3d0d42dca"
export function FooterD10efa2a43d047848b07Fc8195623065(props: any) {
  return (
    <DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 parentTag="FooterD10efa2a43d047848b07Fc8195623065" {...props} />
  );
}

// id: "0e54bce5-e5db-4573-91c7-cc541530d4b2"
// title: "Contact Header Clone CEM6GZI2IPRP07Y1J"
// type: :gf_preset
// key: "header"
// parent_id: "cea9d9ef-69ee-4971-8cab-b2f3d0d42dca"
export function Header0e54bce5E5db457391c7Cc541530d4b2(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header0e54bce5E5db457391c7Cc541530d4b2" parentTag={buildClassName("Header0e54bce5E5db457391c7Cc541530d4b2", parentTag)} subType="header_with_hero" contentSlug="public-faq-header-with-hero" as="header" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "87aea6d8-3e4b-4d9e-83cd-1b6d7251f863"
// title: ""
// type: :gf_preset
// key: "content"
// parent_id: "cea9d9ef-69ee-4971-8cab-b2f3d0d42dca"
export function Content87aea6d83e4b4d9e83cd1b6d7251f863(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Content87aea6d83e4b4d9e83cd1b6d7251f863" parentTag={buildClassName("Content87aea6d83e4b4d9e83cd1b6d7251f863", parentTag)} className="main-content" subType="post" contentSlug="public-faq-main-content" {...props} />
  );
}

// id: "cea9d9ef-69ee-4971-8cab-b2f3d0d42dca"
// title: "FAQ - Frequently Asked Questions"
// type: :html
// key: "public-faq-page"
// parent_id: nil
export function PublicFaqPageCea9d9ef69ee49718cabB2f3d0d42dca(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicFaqPageCea9d9ef69ee49718cabB2f3d0d42dca gf-page-layout`}>
      {props["header"] || <ContentItem className="Header0e54bce5E5db457391c7Cc541530d4b2" parentTag={buildClassName("Header0e54bce5E5db457391c7Cc541530d4b2", parentTag)} subType="header_with_hero" contentSlug="public-faq-header-with-hero" as="header" className="public-header-with-hero secondary-page" {...props} />}
      <main>
        {props["content"] || <ContentItem className="Content87aea6d83e4b4d9e83cd1b6d7251f863" parentTag={buildClassName("Content87aea6d83e4b4d9e83cd1b6d7251f863", parentTag)} className="main-content" subType="post" contentSlug="public-faq-main-content" {...props} />}
      </main>
      {props["footer"] || <DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 parentTag="FooterD10efa2a43d047848b07Fc8195623065" {...props} />}
    </div>
  );
}

// id: "4192a8ed-a2cd-4722-a59e-d974e90caa4e"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePage4192a8edA2cd4722A59eD974e90caa4e(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePage4192a8edA2cd4722A59eD974e90caa4e gf-page-layout`}>
      {props["header"] || <ContentItem className="Header9920565cA4194c7894c2E621afb22e45" parentTag={buildClassName("Header9920565cA4194c7894c2E621afb22e45", parentTag)} subType="header_with_hero" contentSlug="home-header-with-hero" as="header" className="public-header-with-hero home-page" {...props} />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack9865fab49fff4df68eeaBb33ac258d6e" parentTag={buildClassName("WelcomeBack9865fab49fff4df68eeaBb33ac258d6e", parentTag)} {...props} />}
      {props["main"] || <Main8d7e818f9aed49b7A224A8c62df3f3e4 />}
      {props["footer"] || <DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 parentTag="Footer8489f2692f644c7aB6c75a89f3dd514c" {...props} />}
    </div>
  );
}

// id: "11d0ee88-bfdd-4cc1-ab57-e0ae80b42627"
// title: ""
// type: :text
// key: "subType"
// parent_id: "e04c5be0-d435-4297-b914-cb2b7ee853a3"
export const SubType11d0ee88Bfdd4cc1Ab57E0ae80b42627 = "header_with_hero";

// id: "8b3d3f88-0eeb-4fe8-b58b-77acbb62d6ab"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "e04c5be0-d435-4297-b914-cb2b7ee853a3"
export const ContentSlug8b3d3f880eeb4fe8B58b77acbb62d6ab = "public-events-header-with-hero";

// id: "d22388e6-6106-4e0d-9de9-bf1e4625ebb1"
// title: ""
// type: :text
// key: "as"
// parent_id: "e04c5be0-d435-4297-b914-cb2b7ee853a3"
export const AsD22388e661064e0d9de9Bf1e4625ebb1 = "header";

// id: "30ad6a7f-81f7-40d6-883f-cb1b01845ffe"
// title: ""
// type: :text
// key: "className"
// parent_id: "e04c5be0-d435-4297-b914-cb2b7ee853a3"
export const ClassName30ad6a7f81f740d6883fCb1b01845ffe = "public-header-with-hero secondary-page";

// id: "b4c68fd0-7646-4440-9b5d-491b752e0f0c"
// title: ""
// type: :text
// key: "as"
// parent_id: "47cb8600-4fd9-47fd-9ce8-dadb8703004e"
export const AsB4c68fd0764644409b5d491b752e0f0c = "header";

// id: "454c80c6-2d0d-44d4-85c9-fa63906a7b67"
// title: ""
// type: :text
// key: "subType"
// parent_id: "0e54bce5-e5db-4573-91c7-cc541530d4b2"
export const SubType454c80c62d0d44d485c9Fa63906a7b67 = "header_with_hero";

// id: "4e13d23a-2ded-4757-b6ce-b887b662b27c"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "0e54bce5-e5db-4573-91c7-cc541530d4b2"
export const ContentSlug4e13d23a2ded4757B6ceB887b662b27c = "public-faq-header-with-hero";

// id: "b9b26e18-c5cd-44b1-a933-2687ccf6de2c"
// title: ""
// type: :text
// key: "as"
// parent_id: "0e54bce5-e5db-4573-91c7-cc541530d4b2"
export const AsB9b26e18C5cd44b1A9332687ccf6de2c = "header";

// id: "781fd0b6-204b-413c-957b-b68722404211"
// title: ""
// type: :text
// key: "className"
// parent_id: "87aea6d8-3e4b-4d9e-83cd-1b6d7251f863"
export const ClassName781fd0b6204b413c957bB68722404211 = "main-content";

// id: "273888b9-3c59-4064-8941-4d88691a92e0"
// title: ""
// type: :text
// key: "className"
// parent_id: "0e54bce5-e5db-4573-91c7-cc541530d4b2"
export const ClassName273888b93c59406489414d88691a92e0 = "public-header-with-hero secondary-page";

// id: "d541ad42-133d-429a-a16c-4d1b4bd3a434"
// title: ""
// type: :text
// key: "subType"
// parent_id: "87aea6d8-3e4b-4d9e-83cd-1b6d7251f863"
export const SubTypeD541ad42133d429aA16c4d1b4bd3a434 = "post";

// id: "ad855c29-8f78-4e16-8dd6-bd38290bfe05"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "87aea6d8-3e4b-4d9e-83cd-1b6d7251f863"
export const ContentSlugAd855c298f784e168dd6Bd38290bfe05 = "public-faq-main-content";

// id: "d381f58e-36d8-4e3b-9b87-e52cadfa7213"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooterD381f58e36d84e3b9b87E52cadfa7213(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 footer`}>
      {props["links"] || <Navigation className="Links46aef82d7fb048d0924186bfc74d5dc0" parentTag={buildClassName("Links46aef82d7fb048d0924186bfc74d5dc0", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="LogoD4ba98deAa0e4d9cAab8C08b09d4e0a7" parentTag={buildClassName("LogoD4ba98deAa0e4d9cAab8C08b09d4e0a7", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright89733e15B74a49edBc26D9a2f069bfde" parentTag={buildClassName("Copyright89733e15B74a49edBc26D9a2f069bfde", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="GroupflowD2f741c85fed404eB6c1C8b710c789ba" parentTag={buildClassName("GroupflowD2f741c85fed404eB6c1C8b710c789ba", parentTag)} {...props} />}
    </footer>
  );
}

// id: "4b047484-dc19-48a2-bf01-c1c5a44447b1"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPage4b047484Dc1948a2Bf01C1c5a44447b1(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPage4b047484Dc1948a2Bf01C1c5a44447b1`} classname="gf-page-layout">
      {props["header"] || <ContentItem className="Header69cd08b9B0424c18A7e162b4bc101777" parentTag={buildClassName("Header69cd08b9B0424c18A7e162b4bc101777", parentTag)} title="Secondary Page" subType="header_with_hero" contentSlug="join-us-header-with-hero" as="header" className="public-header-with-hero secondary-page" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterD381f58e36d84e3b9b87E52cadfa7213 parentTag="Footer131fdaf5Bb7b47a2810d89ff0f67c719" {...props} />}
    </div>
  );
}

// id: "bb1388eb-cab7-426a-b006-689d73d56336"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHeroBb1388ebCab7426aB006689d73d56336(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeroBb1388ebCab7426aB006689d73d56336 hero`}>
      <h1 className="title">
        {props["title"] || Title36f98216Ddc04eaaA675C4d3dd26646c}
      </h1>
    </div>
  );
}

const Components = {
  Footer8e8139eeEb5e4f6788c5288ecc5774af,
  Header1293791e573c4804Ad905d9bf9aea9fd,
  LocalPartnershipPageD85e97da2c2944c8Aed80dedd24f88e8,
  SubType68df6b9a25c845c2Be4a7365aceb2d63,
  ContentSlugFd97021e57374943A3057de337a8b369,
  As37abe6e6Be8048099a82C67b6e101ecb,
  ClassName97e3f25135c74699Be2c8f9af19bf83f,
  PageContentB7c9d5951033415087202ca50e428f07,
  Class1ef4a984502349daA9cbBc20dd3e8ebf,
  DefaultHeaderTop24ec4652D49c4a82Bc89787abeecd5e1,
  SecondaryMarketingHeaderAbeb3bbf3790485c9a49146f8ef4e521,
  AboutUsPageB8b9bef935664bc69e4eBb11f70aa588,
  PublicEventsPage77ee98ee38524f159c0308335faf554b,
  JoinUsPageF56cb81a742a45f186858f9f64d174d9,
  ApplicationPages0ed336a0Cebe4984Bdbf45bd5ca0af28,
  GroupflowD2f741c85fed404eB6c1C8b710c789ba,
  LogoA379cfa6C5584d118a7eEfde248f5b01,
  HeaderTopC4a8053185f64858A33189694515dada,
  LogoD4ba98deAa0e4d9cAab8C08b09d4e0a7,
  HeaderWrapperFe777d745c6b44bfA88cF61375f38046,
  Footer245b4087231f480a900b4d149734da09,
  LinkedLogoE5e6df9627984d11Af7bA8aefd54ee6d,
  Title36f98216Ddc04eaaA675C4d3dd26646c,
  Main8d7e818f9aed49b7A224A8c62df3f3e4,
  WelcomeBack9865fab49fff4df68eeaBb33ac258d6e,
  MainCd8a74f2Bda549c0A1fb7144fe3395e1,
  HeaderE96366629c5647fd8a35C339265df594,
  Navigation010614acCf8a4eb6Bdb4753417deb98f,
  HeaderE04c5be0D4354297B914Cb2b7ee853a3,
  Title6adc52ce143f4f34A0ac9fa29c85c96c,
  Links46aef82d7fb048d0924186bfc74d5dc0,
  Header69cd08b9B0424c18A7e162b4bc101777,
  FooterEbbaf61e4a93453e9bd75541ce63dcb6,
  Hero1ae07dd2D1f04c74B886Dd16de9b48e1,
  Footer131fdaf5Bb7b47a2810d89ff0f67c719,
  Copyright89733e15B74a49edBc26D9a2f069bfde,
  Quote8cc28b5aA91145ef9d81C328ac8db8ab,
  Footer8489f2692f644c7aB6c75a89f3dd514c,
  Label15eccd7013424328B2a88767782bc61c,
  Class80df85f208354e179d81D83eda32b9ed,
  ClassCa4df4af1c21488d86bc4861adacf55d,
  HeroWrapper81da98e7Ae5f45cc99b9182b4cac5053,
  CardsB6f339d235374c658f27A9e7d29a2b47,
  ContentSlugE77cd94d498344f58233Aa37b8036c65,
  HeaderTop1ff5b58e64bb4e6d9e67E9e7bb83d203,
  LogoType48bee644052f434d955a31d3a489896e,
  NavMenuSlugD6d5f651De6247988c92Ce313f495489,
  Title943484e1Bc4f4802A072018e2a8d31ca,
  Title3e3303ba1cfa4955B15e4eaa9d6736b4,
  UrlF38656c3F3544899B3be223dd0a55358,
  Cards539c40c0A80d41afBd4550efbba2d26b,
  TitleEe6c48e0Aad0435a9d846e7e51070eb1,
  NavMenuSlugF03a0077553f405dAbe154e00ef8d85e,
  LogoTypeD8b7ba33A3b842179007107f5079ad38,
  ContentSlug51b9d6e46c6f45ce9d3b9503b5f20c67,
  Title37b5fa9fF138477cA66a5b051294e2b6,
  ButtonClass9516ed867427421a9d7b2e5dda700f3d,
  PostSlug150b6d185e7d4fc980d213416cd60630,
  Hero1ef4e20615b14654Bf7015286bab1bc5,
  LogoType91a4f9cfD1314090A2f750cd4d7da9ba,
  PostSlugF82550dc07084de6Bb6228bf8c69cac0,
  ContentSlug6a8810faA314419cBc05C0bf49d20181,
  PostSlug091ccf901a044e9dBba22e191606ab17,
  SubType5ce8d7b5E0774b4093f276d4322a5340,
  ContentSlugC619fd519bf64bca98ebFd8eca48b734,
  AsC1480893B1bd4aa5AccaD63e5cfa82a1,
  ClassName3c9fc99e9ebf4bd48699058055848e7e,
  Footer599609032cf64abfA542108e67559326,
  Header47cb86004fd947fd9ce8Dadb8703004e,
  PublicContactPage9b1ae4c4E9ad4b19968c68e997e5436a,
  Quote61b9e7c198a1478a8e0361fb1e54a8e4,
  Header9920565cA4194c7894c2E621afb22e45,
  SubType7ddade68543249418572Ad1ba781a7f1,
  ContentSlugA252504162a34e769db10cf36111d142,
  AsBed9fc9b23504a76B3786ba62cc3b59d,
  ClassNameDaaf050dA07a419fAaa48d63417f1ee6,
  Header6252f33e538f4de392ec2d60827ba2fc,
  SubType53112ed12e99460f8ff083e287ca2f53,
  ContentSlug6b1d4f6f59c0445480d9Cd5a181ba707,
  As6812c019E3b5419fAd5b0b0da035c03b,
  ClassName2a14e1c1056443849a386391827aa3df,
  ContentSlug526899608bcf45858bc28e89c4237299,
  SubType90536bf52f52430c8219D41c54301978,
  ContentSlug216d39fc2ce041b29b9bF56ed3eb0f35,
  AsE7cff4b862444805Bccf1f30c314bf6e,
  ClassName78554e82Dd47440a81ce54e6667720c8,
  Header09c95615207c4204Bcce87f12373a71f,
  FooterB16e3209483d415cA306Caba885a5d74,
  Content6fd55c6a3cc3424192941ab87b33c3c1,
  SubType9c290f56977a4a32Bbfa53e9095521a3,
  ContentSlugDa35881037e543ed8ee03c5a4594e44e,
  ClassName0ceee5c3F6d043cdB8be3b6cc67ae2b2,
  SubType1a1ff60aF5bb43efA73bA297d73e9d23,
  ContentSlug2bed7439A4e04c349809630f8be77b36,
  ClassNameC7dfe1e2Ab5442a0Bcf9Eb27b1785f6a,
  FooterD10efa2a43d047848b07Fc8195623065,
  Header0e54bce5E5db457391c7Cc541530d4b2,
  Content87aea6d83e4b4d9e83cd1b6d7251f863,
  PublicFaqPageCea9d9ef69ee49718cabB2f3d0d42dca,
  HomePage4192a8edA2cd4722A59eD974e90caa4e,
  SubType11d0ee88Bfdd4cc1Ab57E0ae80b42627,
  ContentSlug8b3d3f880eeb4fe8B58b77acbb62d6ab,
  AsD22388e661064e0d9de9Bf1e4625ebb1,
  ClassName30ad6a7f81f740d6883fCb1b01845ffe,
  AsB4c68fd0764644409b5d491b752e0f0c,
  SubType454c80c62d0d44d485c9Fa63906a7b67,
  ContentSlug4e13d23a2ded4757B6ceB887b662b27c,
  AsB9b26e18C5cd44b1A9332687ccf6de2c,
  ClassName781fd0b6204b413c957bB68722404211,
  ClassName273888b93c59406489414d88691a92e0,
  SubTypeD541ad42133d429aA16c4d1b4bd3a434,
  ContentSlugAd855c298f784e168dd6Bd38290bfe05,
  DefaultFooterD381f58e36d84e3b9b87E52cadfa7213,
  SecondaryPage4b047484Dc1948a2Bf01C1c5a44447b1,
  SecondaryMarketingHeroBb1388ebCab7426aB006689d73d56336
}

export default Components;